var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layout"
  }, [_c('Header'), _vm._v(" "), _c('div', {
    staticClass: "main-container-fixed-footer"
  }, [_c('Nuxt'), _vm._v(" "), _c('Footer', {
    staticClass: "mobile-hidden"
  })], 1), _vm._v(" "), _c('Footer', {
    staticClass: "desktop-hidden"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }